import { useState } from 'react';
import { 
  MapPin, 
  Phone, 
  Mail, 
  Clock, 
  Send,
  MessageCircle,
  Truck
} from 'lucide-react';

export const ContactoPage = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    asunto: '',
    mensaje: ''
  });
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simular envío
    setEnviado(true);
    setTimeout(() => setEnviado(false), 3000);
  };

  const sucursales = [
    {
      nombre: "Sede Principal",
      direccion: "Cra. 104 # 103 A - 24, Apartadó, Antioquia, Colombia",
      whatsapp: "(+57) 319 3650538",
      horario: "Lun-Dom: 8:00 AM - 9:00 PM",
      servicios: ["Domicilios",]
    }
  ];

  return (
    <div className="min-h-screen transition-colors duration-300 bg-gray-50">
      
      {/* Header */}
      <section className="py-16 bg-gradient-to-br from-emerald-500 to-teal-600">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Contáctanos
          </h1>
          <p className="text-emerald-100 text-lg max-w-2xl mx-auto">
            Estamos aquí para ayudarte. Escríbenos, llámanos o visítanos en cualquiera de nuestras sedes.
          </p>
        </div>
      </section>

      {/* Información de contacto */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            <a 
              href="https://wa.me/573193650538"
              target="_blank"
              rel="noopener noreferrer"
              className="p-6 rounded-2xl text-center block transition-all hover:scale-[1.02] bg-white shadow-lg"
            >
              <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <MessageCircle className="w-7 h-7 text-green-600" />
              </div>
              <h3 className="font-bold mb-2 text-gray-900">WhatsApp</h3>
              <p className="text-gray-600">(+57) 319 3650538</p>
              <p className="text-sm text-gray-500">Respuesta inmediata</p>
            </a>

            <div className="p-6 rounded-2xl text-center bg-white shadow-lg">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-7 h-7 text-blue-600" />
              </div>
              <h3 className="font-bold mb-2 text-gray-900">Email</h3>
              <p className="text-gray-600">confifarma.amiga@gmail.com</p>
              <p className="text-sm text-gray-500">Ventas y servicio</p>
            </div>

            <div className="p-6 rounded-2xl text-center bg-white shadow-lg">
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="w-7 h-7 text-purple-600" />
              </div>
              <h3 className="font-bold mb-2 text-gray-900">Horario</h3>
              <p className="text-gray-600">Lun-Dom: 8:00 AM - 9:00 PM</p>
              <p className="text-sm text-gray-500">Domicilios Lun-Dom</p>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Formulario */}
            <div className="p-8 rounded-2xl bg-white shadow-lg">
              <h2 className="text-2xl font-bold mb-6 text-gray-900">
                Envíanos un mensaje
              </h2>
              
              {enviado ? (
                <div className="p-6 bg-emerald-100 rounded-xl text-center">
                  <div className="w-16 h-16 bg-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Send className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-emerald-700 mb-2">
                    ¡Mensaje enviado!
                  </h3>
                  <p className="text-emerald-600">
                    Te responderemos lo antes posible.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-medium mb-2 text-gray-700">
                        Nombre completo
                      </label>
                      <input
                        type="text"
                        required
                        className="w-full px-4 py-3 rounded-xl border-2 transition-colors bg-gray-50 border-gray-200 text-gray-900 focus:border-emerald-500"
                        placeholder="Tu nombre"
                        value={formData.nombre}
                        onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-2 text-gray-700">
                        Email
                      </label>
                      <input
                        type="email"
                        required
                        className="w-full px-4 py-3 rounded-xl border-2 transition-colors bg-gray-50 border-gray-200 text-gray-900 focus:border-emerald-500"
                        placeholder="tu@email.com"
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-medium mb-2 text-gray-700">
                        Teléfono
                      </label>
                      <input
                        type="tel"
                        className="w-full px-4 py-3 rounded-xl border-2 transition-colors bg-gray-50 border-gray-200 text-gray-900 focus:border-emerald-500"
                        placeholder="(300) 123-4567"
                        value={formData.telefono}
                        onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-2 text-gray-700">
                        Asunto
                      </label>
                      <select
                        required
                        className="w-full px-4 py-3 rounded-xl border-2 transition-colors bg-gray-50 border-gray-200 text-gray-900 focus:border-emerald-500"
                        value={formData.asunto}
                        onChange={(e) => setFormData({...formData, asunto: e.target.value})}
                      >
                        <option value="">Selecciona un asunto</option>
                        <option value="pedido">Consulta sobre pedido</option>
                        <option value="producto">Información de producto</option>
                        <option value="domicilio">Servicio de domicilio</option>
                        <option value="receta">Validación de receta</option>
                        <option value="otro">Otro</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2 text-gray-700">
                      Mensaje
                    </label>
                    <textarea
                      rows={4}
                      required
                      className="w-full px-4 py-3 rounded-xl border-2 transition-colors resize-none bg-gray-50 border-gray-200 text-gray-900 focus:border-emerald-500"
                      placeholder="¿En qué podemos ayudarte?"
                      value={formData.mensaje}
                      onChange={(e) => setFormData({...formData, mensaje: e.target.value})}
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="w-full py-4 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-bold transition-colors flex items-center justify-center space-x-2"
                  >
                    <Send className="w-5 h-5" />
                    <span>Enviar mensaje</span>
                  </button>
                </form>
              )}
            </div>

            {/* Mapa placeholder y sedes */}
            <div>
              <div className="p-8 rounded-2xl mb-6 bg-white shadow-lg">
                <h2 className="text-2xl font-bold mb-6 text-gray-900">
                  Nuestras Sedes
                </h2>
                
                <div className="space-y-4">
                  {sucursales.map((sucursal, index) => (
                    <div 
                      key={index}
                      className="p-4 rounded-xl border-l-4 border-emerald-500 bg-gray-50"
                    >
                      <h3 className="font-bold mb-2 text-gray-900">
                        {sucursal.nombre}
                      </h3>
                      <div className="space-y-1 text-sm text-gray-600">
                        <p className="flex items-center">
                          <MapPin className="w-4 h-4 mr-2 text-emerald-500" />
                          {sucursal.direccion}
                        </p>
                        <p className="flex items-center">
                          <MessageCircle className="w-4 h-4 mr-2 text-emerald-500" />
                          {sucursal.whatsapp}
                        </p>
                        <p className="flex items-center">
                          <Clock className="w-4 h-4 mr-2 text-emerald-500" />
                          {sucursal.horario}
                        </p>
                      </div>
                      <div className="flex flex-wrap gap-2 mt-3">
                        {sucursal.servicios.map((servicio, idx) => (
                          <span 
                            key={idx}
                            className="text-xs px-2 py-1 bg-emerald-100 text-emerald-700 rounded-full"
                          >
                            {servicio}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Map placeholder */}
              <div className="p-8 rounded-2xl text-center bg-white shadow-lg">
                <div className="h-48 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-xl flex items-center justify-center mb-4">
                  <div>
                    <MapPin className="w-12 h-12 text-emerald-600 mx-auto mb-2" />
                    <p className="text-emerald-700 font-medium">Mapa de ubicación</p>
                  </div>
                </div>
                <a 
                  href="https://maps.google.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white rounded-xl font-medium hover:bg-emerald-700 transition-colors"
                >
                  Ver en Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA WhatsApp */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-3xl p-8 md:p-12 text-center bg-gradient-to-br from-green-500 to-green-600">
            <MessageCircle className="w-16 h-16 text-white mx-auto mb-4" />
            <h2 className="text-3xl font-bold text-white mb-4">
              ¿Prefieres escribirnos?
            </h2>
            <p className="text-green-100 mb-8 max-w-2xl mx-auto">
              Estamos disponibles por WhatsApp para atenderte de forma rápida. 
              Escríbenos y te responderemos en minutos.
            </p>
            <a 
              href="https://wa.me/573193650538"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-8 py-4 bg-white text-green-600 rounded-xl font-bold hover:bg-gray-100 transition-colors"
            >
              <MessageCircle className="w-5 h-5" />
              <span>Chatear por WhatsApp</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactoPage;
